var homeSlider = new Swiper('.home__slider_JS', {
	slidesPerView: 1,
    //spaceBetween: 50,
    loop: true,
    pagination: {
        el: '.home__pagination_JS',
        clickable: true,
    },
    navigation: {
        nextEl: '.home__button--next_JS',
        prevEl: '.home__button--prev_JS',
    },
});



// WEBPACK FOOTER //
// ./resources/assets/js/slider-home.js